import React from 'react';
import PropTypes from 'prop-types';
import ConnectedUserBehavior from './ConnectedUserBehavior';

const UserBehaviorRouting = ({ match }) => <ConnectedUserBehavior />;
UserBehaviorRouting.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      patientIds: PropTypes.string,
    }),
  }),
};

export default UserBehaviorRouting;
